import React, { useEffect, useRef, useState } from "react";

const DEFAULT_PAGE_SIZE = 50;

// Generic "Basic View" list pane for the master-detail split (design concept
// approved 2026-08-28, made reusable 2026-08-29 after the Employee Master
// pilot so Customers - and future modules - don't re-hand-roll the same
// header/filters/infinite-scroll wiring). Renders items in batches with
// infinite scroll instead of all at once, since an "All branches" fetch can
// be thousands of rows and this list has no windowing/virtualization the way
// antd's old Table got for free via its own pagination.
//
// `resetKey` should change whenever the caller's filters change (e.g. a
// join of search/status/department) so the visible batch resets to the
// first page instead of staying scrolled deep into a now-stale result set.
const MasterDetailListShell = ({
  title,
  addButton,
  filters,
  isLoading,
  emptyLabel = "No records match these filters.",
  items,
  getKey,
  renderItem,
  resetKey,
  pageSize = DEFAULT_PAGE_SIZE,
}) => {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  useEffect(() => {
    setVisibleCount(pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const scrollRef = useRef(null);
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 200) {
      setVisibleCount((c) => Math.min(c + pageSize, items.length));
    }
  };
  const visibleItems = items.slice(0, visibleCount);

  return (
    <div className="master-detail-list-inner">
      <div className="page-header master-detail-list-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>{title}</h4>
            <h6>{visibleItems.length} of {items.length} shown</h6>
          </div>
        </div>
        {addButton && <div className="page-btn">{addButton}</div>}
      </div>

      {filters && <div className="master-detail-list-filters">{filters}</div>}

      <div className="master-detail-list-rows-scroll" ref={scrollRef} onScroll={handleScroll}>
        <ul className="master-detail-list-rows">
          {isLoading && <li className="text-muted small px-3 py-2">Loading...</li>}
          {!isLoading && items.length === 0 && (
            <li className="text-muted small px-3 py-2">{emptyLabel}</li>
          )}
          {visibleItems.map((item) => (
            <React.Fragment key={getKey(item)}>{renderItem(item)}</React.Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MasterDetailListShell;
